import request from '@/utils/request'

export function select_show(id) {
  return request.get('games/selectGameShow.json?id=' + id)
}
